export function addGoogleAnalytics() {
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_MEASUREMENT_ID as string}`;
    script.async = true;
    document.head.appendChild(script);
    const scriptDataLayer = document.createElement("script");
    scriptDataLayer.text = `window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', '${process.env.REACT_APP_GA_MEASUREMENT_ID as string}');`;
    document.head.appendChild(scriptDataLayer);
}

export function sendEvent(eventName: string, eventDetails: any = {}) {
    (window as any).gtag("event", eventName, eventDetails);
}
